import "./footer.scss"

export default function Footer() {
  return (
    <div className="FooterCont">
      <p>© 2025 Fitogether Inc. -- All Rights Reserved.</p>
      <img src="/images/Empowered-by-Aspire.png" alt="Aspire logo" className="powered-by Aspire" />
    </div>
  )
}
